import {
  ProViewSetInput,
  useProFormArchiveModalQuery,
  useProFormArchiveModalUpdateMutation,
} from 'generated/graphql';
import React, { FunctionComponent, useCallback } from 'react';
import ProFormArchiveModalContainer from './pro-form-archive-modal-container';

type ProFormArchiveModalRepositoryProps = ProFormArchiveModalProps & {
  proViewId: number;
  companyId?: number;
  onProArchived?: (proViewId: number) => void;
};

export type ProFormArchiveModalProps = {
  open: boolean;
  onClose?: () => void;
};

export type ProFormArchiveFields = {
  proViewIds: number[];
  dateArchiveScheduled?: Date;
  archiveReason: string;
};

export const ProFormArchiveModalRepository: FunctionComponent<
  ProFormArchiveModalRepositoryProps
> = ({ proViewId, companyId, ...rest }) => {
  const { data, refetch } = useProFormArchiveModalQuery({
    variables: {
      companyId: companyId ?? 0,
      proViewId: proViewId,
    },
  });

  const [proFormArchiveModalUpdate] = useProFormArchiveModalUpdateMutation();

  const updateProView = useCallback(
    async (proViewIds: number[], set: ProViewSetInput) => {
      const { data } = await proFormArchiveModalUpdate({
        variables: { proViewIds, set },
      });

      return data?.updateProView?.returning.map(({ id }) => id);
    },
    [proFormArchiveModalUpdate],
  );

  return (
    <ProFormArchiveModalContainer
      proViews={data?.company?.proPresentations.flatMap(
        ({ proViews }) => proViews,
      )}
      proViewId={proViewId}
      companyId={companyId}
      updateProView={updateProView}
      refetch={refetch}
      {...rest}
    />
  );
};
